module.exports = __webpack_public_path__ + "static/necromancer_wall-01b1d38bebc03d5dc9a1f4817e93133a.jpg";